import React from 'react'
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { InvoiceList } from '../invoice/InvoiceListContainer'
import { useNavigate } from 'react-router-dom'
import { ConcreteTenderList } from '../concrete-tender/ConcreteTenderListContainer'
import { toastWarning } from '../../shared/toastr'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'
import { DropdownMenu, DropdownMenuActionLink } from '../../shared/elements/DropdownMenu'
import { OnboardingMultiStepModal } from '../../v2/components/ui/onboarding-multi-step-modal'
import { InvoiceApi } from '../../services/InvoiceApi'
import { ConcreteTenderApi } from '../../services/ConcreteTenderApi'

export const DashboardContainer = () => {
    const { t } = useOfferionTranslation()
    const dashboardLabel = t('Dashboard.pageTitle')

    return (
        <div className="dashboard-container">
            <OnboardingMultiStepModal />

            <BreadcrumbsItem to="/dashboard">{dashboardLabel}</BreadcrumbsItem>

            <InvoiceList
                gridTitleKey="Dashboard.lastFiveInvoices"
                pageTitleKey={dashboardLabel}
                hideFilters={true}
                hidePaging={true}
                defaultPageSize={5}
                buttons={() => {
                    return <Actions />
                }}
            />

            <ConcreteTenderList
                gridTitleKey=""
                pageTitleKey="Dashboard.lastFiveOffers"
                hideFilters={true}
                hidePaging={true}
                hideHeader={true}
                defaultPageSize={5}
                buttons={() => null}
            />
        </div>
    )
}

function Actions() {
    const { t } = useOfferionTranslation()
    const navigate = useNavigate()

    const handleCreateOffer = async () => {
        const result = await ConcreteTenderApi.createForClient(null)

        if (result.id) {
            navigate(`/offer/${result.id}`, { state: { createFlow: true } })
        } else {
            const message = t('Allaround.Message.packageLimitReached', {
                offersOrInvoicesGenitiv: t('Allaround.Message.offersGenitiv'),
            })

            toastWarning(message, true)
        }
    }

    const handleCreateInvoice = async () => {
        const result = await InvoiceApi.createForClient(null)

        if (result.id) {
            navigate(`/invoice/${result.id}`, { state: { createFlow: true } })
        } else {
            const message = t('Allaround.Message.packageLimitReached', {
                offersOrInvoicesGenitiv: t('Allaround.Message.invoicesGenitiv'),
            })

            toastWarning(message, true)
        }
    }

    return (
        <>
            {/* Mobile screen - dropdown */}
            <div className="table__button-container small-only">
                <DropdownMenu icon="plus">
                    <DropdownMenuActionLink onClick={handleCreateOffer} translationKey="Offers.Header.newOffer" />
                    <DropdownMenuActionLink onClick={handleCreateInvoice} translationKey="Invoices.Header.newInvoice" />
                </DropdownMenu>
            </div>

            {/* Larger screen - regular buttons */}
            <div className="table__button-container small-hide">
                <button className="button button--white table__button" onClick={handleCreateOffer}>
                    <span className="icon icon__plus"></span>
                </button>
                <span className="button-text table__button-text mod-margin-left-4">{t('Offers.Header.newOffer')}</span>
            </div>

            <div className="table__button-container small-hide">
                <button className="button button--white table__button" onClick={handleCreateInvoice}>
                    <span className="icon icon__plus"></span>
                </button>
                <span className="button-text table__button-text mod-margin-left-4">{t('Invoices.Header.newInvoice')}</span>
            </div>
        </>
    )
}
